import { Routes, Route } from 'react-router-dom';
import Started from './../Pages/Started/index';
import Schedule from './../Components/Schedule/index';
import Credit from '../Pages/Credit';
import Register from './../Pages/Register/index';
import CustomerDetails from "../Pages/CustomerDetails/index";
import Nepalidate from "../Pages/NepaliDate/Nepalidate";
import InquiryPage from '../Pages/Inquiry/InquiryPage';


const Routing = () => {
  return (
    <div>
      <Routes>
        <Route path="/started" element={<Started />} />
        <Route path="/register" element={<Register />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/CustomerDetails" element={<CustomerDetails />} />
        <Route path="/availability" element={<Nepalidate />} />
        <Route path="/credit" element={<Credit />} />
        <Route path='/inquirypage' element={<InquiryPage />} />
      </Routes>
    </div>
  )
}

export default Routing